import api from '@/lib/api';

let debounceTimer = null;

/**
 * Decode an Italian Codice Fiscale to extract birth date, sex, and birth place.
 * Calls backend API /utility/decodifica-cf/{cf}
 * @param {string} cf - The fiscal code (16 chars)
 * @returns {Promise<object|null>} Decoded data or null
 */
export async function decodeCF(cf) {
  cf = cf?.toUpperCase().replace(/\s/g, '') || '';
  if (cf.length !== 16 || !/^[A-Z0-9]{16}$/.test(cf)) return null;
  try {
    const res = await api.get(`/utility/decodifica-cf/${cf}`);
    return res.data;
  } catch {
    return null;
  }
}

/**
 * Auto-decode CF with debounce. Call this from onChange handlers.
 * When CF reaches 16 valid chars, decodes and calls onResult.
 * @param {string} cf - Current CF value
 * @param {function} onResult - Callback with decoded data { data_nascita, sesso, luogo_nascita, eta }
 */
export function autoDecodeCF(cf, onResult) {
  if (debounceTimer) clearTimeout(debounceTimer);
  cf = cf?.toUpperCase().replace(/\s/g, '') || '';
  if (cf.length !== 16 || !/^[A-Z0-9]{16}$/.test(cf)) return;
  debounceTimer = setTimeout(async () => {
    const result = await decodeCF(cf);
    if (result && !result.raw && onResult) onResult(result);
  }, 300);
}
